var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
/*
 * Copyright (c) 2019-present Sonatype, Inc.
 * This program and the accompanying materials are made available under
 * the terms of the Eclipse Public License 2.0 which accompanies this
 * distribution and is available at https://www.eclipse.org/legal/epl-2.0/.
 */
import React, { useContext } from 'react';
import classnames from 'classnames';
import TabContext from './TabContext';
import { nxTabPropTypes } from './types';
import NxOverflowTooltip from '../NxTooltip/NxOverflowTooltip';
var SPACE = ' ';
var NxTab = function NxTabElement(props) {
    var _a = useContext(TabContext), activeTab = _a.activeTab, rootId = _a.rootId, index = _a.index, onTabSelect = _a.onTabSelect;
    var _b = props.tabIndex, tabIndex = _b === void 0 ? 0 : _b, className = props.className, children = props.children, onClick = props.onClick, onKeyPress = props.onKeyPress, attrs = __rest(props, ["tabIndex", "className", "children", "onClick", "onKeyPress"]);
    var active = activeTab === index;
    var classNames = classnames('nx-tab', className, { active: active });
    function handleKeyPress(event) {
        if (onKeyPress) {
            onKeyPress(event);
        }
        if (!event.isDefaultPrevented() && (event.key === SPACE || event.key === 'Enter')) {
            event.preventDefault();
            onTabSelect(index);
        }
    }
    function handleClick(event) {
        if (onClick) {
            onClick(event);
        }
        if (!event.isDefaultPrevented()) {
            onTabSelect(index);
        }
    }
    return (React.createElement(NxOverflowTooltip, { title: children },
        React.createElement("li", __assign({ role: "tab", id: rootId + "-tab-" + index, "aria-controls": rootId + "-tabpanel-" + index, className: classNames, "aria-selected": active, onKeyPress: handleKeyPress, onClick: handleClick, tabIndex: tabIndex }, attrs),
            children,
            React.createElement("div", { className: "nx-tab__hidden-children" }, children))));
};
NxTab.propTypes = nxTabPropTypes;
export default NxTab;
//# sourceMappingURL=NxTab.js.map